import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataClickArea,
  AnalyticsDataClickPathAppStore,
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventClickAppStore,
} from 'src/types/googleAnalyticsEvents';

const mapStoreTypeToClickPath = {
  'app-store': AnalyticsDataClickPathAppStore.appleAppStore,
  'google-play': AnalyticsDataClickPathAppStore.googlePlayStore,
};

export function useEventClickAppStore(
  storeType: 'app-store' | 'google-play',
  clickArea: AnalyticsDataClickArea = AnalyticsDataClickArea.content,
): AnalyticsEventClickAppStore {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.clickAppStore,
      [AnalyticsDataProperty.clickArea]: clickArea,
      [AnalyticsDataProperty.clickPath]: mapStoreTypeToClickPath[storeType],
      ...trackedPageContext,
    }),
    [clickArea, storeType, trackedPageContext],
  );
}
